import { IoSparklesOutline } from "react-icons/io5";

// ─────────────────────────────────────────────
//  Single Workshop Card
//  Props (will come from Django API eventually):
//    tag         – "Featured Workshop"
//    title       – "Robotics & Intelligent Machines"
//    image       – image URL string
//    imageAlt    – alt text for image
//    description – paragraph text (string)
//    outcomes    – array of strings  ["Understand robotics...", ...]
//    buttonText  – "Register Now"
//    buttonLink  – URL string
// ─────────────────────────────────────────────
function WorkshopCard({
  tag,
  title,
  image,
  imageAlt,
  description,
  outcomes = [],
  buttonText = "Register Now",
  buttonLink = "#",
  onRegister,
}) {
  return (
    <section className="py-5 bg-white">
      <div className="container py-lg-4" style={{ maxWidth: "1100px" }}>
        {/* Tag label */}
        {tag && (
          <p
            className="mb-2 fw-medium"
            style={{ color: "#b54a2e", fontSize: "14px" }}
          >
            {tag}
          </p>
        )}

        {/* Large title */}
        <h2 className="display-5 fw-medium text-dark mb-4">{title}</h2>

        {/* Two-column layout: image left, content right */}
        <div className="row g-5 align-items-start">
          {/* Left – Image */}
          <div className="col-12 col-lg-6">
            <img
              src={image}
              alt={imageAlt || title}
              className="img-fluid rounded-3 w-100"
              style={{ objectFit: "cover", maxHeight: "420px" }}
            />
          </div>

          {/* Right – Content */}
          <div className="col-12 col-lg-6">
            <h3 className="h4 fw-medium text-dark mb-3">{title}</h3>

            {/* Description */}
            <p className="text-secondary mb-4" style={{ lineHeight: "1.7" }}>
              {description}
            </p>

            {/* Learning Outcome */}
            {outcomes.length > 0 && (
              <>
                <h4 className="h5 fw-medium text-dark mb-3">
                  Learning Outcomes
                </h4>
                <ul className="list-unstyled mb-4">
                  {outcomes.map((outcome, index) => (
                    <li
                      key={index}
                      className="d-flex align-items-start gap-2 mb-2 text-secondary"
                      style={{ fontSize: "15px", lineHeight: "1.6" }}
                    >
                      <IoSparklesOutline
                        size={16}
                        color="#b54a2e"
                        style={{ marginTop: "4px", flexShrink: 0 }}
                      />
                      {outcome}
                    </li>
                  ))}
                </ul>
              </>
            )}

            {/* Register Now button */}
            <button
              onClick={onRegister}
              className="btn btn-brand px-4 py-2 d-inline-flex align-items-center gap-2"
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WorkshopCard;
